module.exports = __webpack_public_path__ + "img/test1.b14c19d9.png";